import { getColor } from '../../../../theme-tools';
function baseStyleTrack(props) {
  var {
    theme
  } = props;
  return {
    borderRadius: '3px',
    p: '3px',
    bg: 'white',
    border: "2px solid ".concat(getColor(theme, 'blue.275')),
    _focus: {
      border: "2px solid ".concat(getColor(theme, 'blue.200')),
      boxShadow: "0 0 3px 2px ".concat(getColor(theme, 'blue.300'))
    },
    _disabled: {
      bg: 'white',
      border: "2px solid ".concat(getColor(theme, 'grey.400')),
      cursor: 'not-allowed',
      '.tqc-switch__thumb': {
        bg: 'grey.400',
        borderColor: 'grey.400'
      }
    }
  };
}
var sizes = {
  sm: {
    container: {
      '--slider-track-width': '1.25rem',
      '--slider-track-height': '0.75rem'
    }
  },
  md: {
    container: {
      '--slider-track-width': '2.375rem',
      '--slider-track-height': '1rem'
    }
  },
  lg: {
    container: {
      '--slider-track-width': '2.75rem',
      '--slider-track-height': '1.5rem'
    }
  }
};
var baseStyleThumb = {
  bg: 'blue.275',
  border: '1px solid',
  borderRadius: '3px',
  borderColor: 'blue.275'
};
var baseStyle = props => ({
  track: baseStyleTrack(props),
  thumb: baseStyleThumb
});
export var Switch = {
  baseStyle,
  sizes
};